
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { default as __Next_Translate_old_getServerSideProps__1a06c87ef49__ } from '@utils/serverSide/book/getBookServerSideProps';
import Book from '@screens/Books/Book';
import withRestrictions from '@utils/hoc/withRestrictions';
export {} from '@utils/serverSide/book/getBookServerSideProps';
export default withRestrictions(Book);

    async function __Next_Translate__getServerSideProps__1a06c87ef49__(ctx) {
      const res = await __Next_Translate_old_getServerSideProps__1a06c87ef49__(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/books/[bookId]/[bookPath]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a06c87ef49__ as getServerSideProps }
  